import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { callsAtom } from '../states';
import { CallStatus } from '../typings';

/**
 * Hook to cleanup all active calls
 */
export const useCleanupCalls = () => {
  const [calls, setCalls] = useAtom(callsAtom);

  const cleanupAllCalls = useCallback(() => {
    // Mark all active calls as forcefully disconnected
    const updatedCalls = calls.map((call) => {
      if (call.status === CallStatus.IN_PROGRESS || call.status === CallStatus.Connecting) {
        return {
          ...call,
          shouldForceDisconnect: true,
        };
      }
      return call;
    });
    setCalls(updatedCalls);
  }, [calls, setCalls]);

  return {
    cleanupAllCalls,
  };
};
